import Handlebars from 'handlebars';

import ModalTemplate from 'templates/modals/social-slider.html';


export default class StockistsModal {
    constructor (triggerElement, items) {
        this.triggerElement = triggerElement;
        this.items = items;

        this.bindTriggerEvents();
    }

    bindTriggerEvents () {
        this.triggerElement.addEventListener('click', this.openModal.bind(this), false);
    }

    openModal (e) {
        e.preventDefault();

        const rendered = Handlebars.compile(ModalTemplate)({ items: this.items });
        document.body.insertAdjacentHTML('beforeend', rendered);
        this.element = document.querySelector('.js-modal');

        document.documentElement.classList.add('is-inactive');

        this.bindModalEvents();
    }

    bindModalEvents () {
        [...this.element.querySelectorAll('.js-close')].forEach((closeEl) => {
            closeEl.addEventListener('click', this.closeModal.bind(this));
        });
    }

    closeModal () {
        this.element.parentNode.removeChild(this.element);

        document.documentElement.classList.remove('is-inactive');
    }
}



// WEBPACK FOOTER //
// ./lib/social-slider.js